import { join } from 'path'
import { getCookie } from '@/utils/get-cookie'

export default function ({ $axios, app }, inject) {
  $axios.setBaseURL(join(app.router.options.base, 'api'))
  $axios.setHeader('X-CSRFToken', getCookie('csrftoken'))

  if (window.Cypress) {
    Cypress.cancelToken = $axios.CancelToken.source()
  }

  $axios.onRequest((config) => {
    if (window.Cypress) {
      config.cancelToken = Cypress.cancelToken.token
    }
  })

  $axios.onError((error) => {
    if ($axios.isCancel(error)) {
      return Promise.resolve()
    }
  })

  inject('api', $axios)
}
